
















import { Vue, Component } from "vue-property-decorator";
import { format } from "date-fns";
import IconInfoFill from "@/components/icons/IconInfoFill.vue";
import IconGiftFill from "@/components/icons/IconGiftFill.vue";
import IconFire from "@/components/icons/IconFire.vue";
import IconWarningFill from "@/components/icons/IconWarningFill.vue";

@Component({
  components: { IconFire, IconGiftFill, IconWarningFill, IconInfoFill },
  props: {
    text: { type: String, default: "" },
    date: { type: String, default: "" },
    icon: { type: String, default: "info" },
    isNew: { type: Boolean, default: false },
  },
})
export default class NotificationItem extends Vue {
  getFormatedDate(date: string) {
    const convertedDate = new Date(date);
    return format(convertedDate, "dd.MM.yyyy kk:mm");
  }
  getIcon(icon: string) {
    switch (icon) {
      case "warning":
        return IconWarningFill;
      case "gift":
        return IconGiftFill;
      case "fire":
        return IconFire;
      default:
        return IconInfoFill;
    }
  }
}
